import { render, staticRenderFns } from "./IconLogOut.vue?vue&type=template&id=58bad464"
import script from "./IconLogOut.vue?vue&type=script&lang=js"
export * from "./IconLogOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports